import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/img/filter.svg'
import _imports_1 from '../../assets/img/close_x.svg'
import _imports_2 from '../../assets/img/suche_Lupe_black.svg'
import _imports_3 from '../../assets/img/switch-filter.svg'
import _imports_4 from '../../assets/img/switch-karte.svg'
import _imports_5 from '../../assets/img/switch-liste.svg'


const _hoisted_1 = {
  key: 0,
  class: "visually-hidden"
}
const _hoisted_2 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = {
  id: "main",
  class: ""
}
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = { class: "row mx-0" }
const _hoisted_14 = { class: "col-12 col-md-6 col-lg-3 ps-0 px-xs-0" }
const _hoisted_15 = { class: "col-12 col-md-6 col-lg-9 p-0 ps-5px bg-white d-nonex d-md-block position-relative" }
const _hoisted_16 = {
  class: "karte",
  id: "karte-desktop",
  ref: "kartedesktop",
  "aria-labelledby": "karte-headline"
}
const _hoisted_17 = {
  id: "karte-headline",
  class: "visually-hidden"
}
const _hoisted_18 = { class: "container px-0" }
const _hoisted_19 = { class: "row mx-0" }
const _hoisted_20 = {
  class: "col-12 col-md-6 col-lg-3 px-xs-0 ps-sm-0 d-none d-md-block",
  id: "ergebnisfilter-holder"
}
const _hoisted_21 = {
  id: "ergebnis-filter",
  ref: "ergebnisfilter",
  tabindex: "0",
  "aria-labelledby": "ergebnis-headline"
}
const _hoisted_22 = { class: "ergebnis-filter-box" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = ["alt"]
const _hoisted_25 = {
  class: "filter-headline",
  id: "ergebnis-headline"
}
const _hoisted_26 = { class: "input-group position-relative mt-3" }
const _hoisted_27 = {
  for: "search-menue",
  class: "visually-hidden"
}
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = ["alt"]
const _hoisted_30 = { class: "visually-hidden alert-primary" }
const _hoisted_31 = ["alt"]
const _hoisted_32 = { class: "visually-hidden alert-primary" }
const _hoisted_33 = { class: "ergebnis-filter-box" }
const _hoisted_34 = { class: "list-unstyled" }
const _hoisted_35 = { class: "form-check" }
const _hoisted_36 = {
  class: "form-check-label checkbox-label d-flex align-items-center",
  for: 'cb_beratung_chat'
}
const _hoisted_37 = { class: "ms-auto ps-2 pe-1 checkbox-label-number" }
const _hoisted_38 = { class: "form-check" }
const _hoisted_39 = {
  class: "form-check-label checkbox-label d-flex align-items-center",
  for: 'cb_beratung_video'
}
const _hoisted_40 = { class: "ms-auto ps-2 pe-1 checkbox-label-number" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = {
  class: "form-check-label checkbox-label d-flex align-items-center",
  for: 'cb_beratung_mail'
}
const _hoisted_43 = { class: "ms-auto ps-2 pe-1 checkbox-label-number" }
const _hoisted_44 = {
  key: 0,
  class: "ergebnis-filter-box"
}
const _hoisted_45 = { class: "list-unstyled" }
const _hoisted_46 = { class: "form-check" }
const _hoisted_47 = ["checked"]
const _hoisted_48 = {
  class: "form-check-label checkbox-label d-flex align-items-center",
  for: "cb_beratung_all"
}
const _hoisted_49 = {
  key: 0,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_50 = {
  key: 1,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_51 = { class: "form-check" }
const _hoisted_52 = ["value", "id", "checked", "disabled"]
const _hoisted_53 = ["for"]
const _hoisted_54 = {
  key: 0,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_55 = {
  key: 1,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_56 = {
  key: 1,
  class: "ergebnis-filter-box"
}
const _hoisted_57 = { class: "list-unstyled" }
const _hoisted_58 = { class: "form-check" }
const _hoisted_59 = ["value", "id", "checked", "disabled"]
const _hoisted_60 = ["for"]
const _hoisted_61 = {
  key: 0,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_62 = {
  key: 1,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_63 = {
  key: 2,
  class: "ergebnis-filter-box"
}
const _hoisted_64 = { class: "list-unstyled" }
const _hoisted_65 = { class: "form-check" }
const _hoisted_66 = ["value", "id", "checked", "disabled"]
const _hoisted_67 = ["for"]
const _hoisted_68 = {
  key: 0,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_69 = {
  key: 1,
  class: "ms-auto ps-2 pe-1 checkbox-label-number"
}
const _hoisted_70 = { class: "ergebnis-filter-box" }
const _hoisted_71 = { class: "col-12 col-md-6 col-lg-9 px-xs-0 mt-4 mt-md-0 pe-md-0 padding-ergebnisliste-start" }
const _hoisted_72 = {
  id: "ergebnis-liste",
  "aria-live": "polite",
  "aria-relevant": "additions removals",
  ref: "ergebnisliste",
  tabindex: "0",
  "aria-labelledby": "liste-headline"
}
const _hoisted_73 = {
  class: "visually-hidden",
  id: "liste-headline"
}
const _hoisted_74 = {
  key: 0,
  class: "d-block d-md-none d-flex justify-content-evenly",
  id: "mobileSwitch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetBeratungsSuche = _resolveComponent("WidgetBeratungsSuche")!
  const _component_Karte = _resolveComponent("Karte")!
  const _component_Liste = _resolveComponent("Liste")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.messages)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.hiddenh1), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ol", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _createElementVNode("a", { href: _ctx.langMain }, _toDisplayString(_ctx.$t('detailviews.home')), 9, _hoisted_9)
                ]),
                _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.$t('detailviews.counselingCenters')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_11, [
      _createElementVNode("section", {
        class: "container kartenbox mb-4 px-xs-0",
        id: "karte",
        "aria-label": _ctx.$t('searchlist.search')
      }, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(), _createBlock(_component_WidgetBeratungsSuche, {
              messages: _ctx.messages,
              type: "search",
              selectedTopics: _ctx.topics,
              selectedRegion: _ctx.regions,
              onSubmit: _ctx.getnewtopics,
              selectedLong: _ctx.long,
              selectedLat: _ctx.lat,
              key: _ctx.componentKey
            }, null, 8, ["messages", "selectedTopics", "selectedRegion", "onSubmit", "selectedLong", "selectedLat"]))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('searchlist.mapHL')), 1),
              _createVNode(_component_Karte, {
                "c-centers": _ctx.filteredCenter,
                "show-search-area-overlay": false,
                onUpdateFromAreaSearchButton: _ctx.searchArea
              }, null, 8, ["c-centers", "onUpdateFromAreaSearchButton"])
            ], 512)
          ])
        ])
      ], 8, _hoisted_12),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    width: "20",
                    height: "20",
                    alt: _ctx.$t('searchlist.filterIcon'),
                    "aria-hidden": "true",
                    class: "me-3"
                  }, null, 8, _hoisted_24),
                  _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t('searchlist.filter')), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('searchlist.searchTerm')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "search-menue",
                    name: "q",
                    class: "form-control custom-search-input w-100",
                    placeholder: _ctx.$t('searchlist.search'),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchByTerm()), ["enter"])),
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchByTerm())),
                    "aria-controls": "ergebnis-liste"
                  }, null, 40, _hoisted_28), [
                    [_vModelText, _ctx.searchTerm]
                  ]),
                  (_ctx.searchTerm && _ctx.searchTerm.length > 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-suche bg-white custom-search-button custom-search-button-delete",
                        role: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetTerm()))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          width: "10",
                          height: "10",
                          alt: _ctx.$t('searchlist.deleteIcon'),
                          "aria-hidden": "true"
                        }, null, 8, _hoisted_29),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('searchlist.resetInput')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-suche bg-white custom-search-button",
                    role: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchByTerm()))
                  }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      width: "20",
                      height: "20",
                      alt: _ctx.$t('searchlist.searchIcon'),
                      "aria-hidden": "true"
                    }, null, 8, _hoisted_31),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('searchlist.search')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('searchlist.onlineCounseling')), 1),
                _createElementVNode("ul", _hoisted_34, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "Chat",
                        name: "os",
                        id: 'cb_beratung_chat',
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkedOnlineService) = $event)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkOnlineService($event))),
                        "aria-controls": "ergebnis-liste"
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.checkedOnlineService]
                      ]),
                      _createElementVNode("label", _hoisted_36, [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.counselingCenters.chatConsult')) + " ", 1),
                        _cache[24] || (_cache[24] = _createElementVNode("i", { class: "icon onb-contact--chat" }, null, -1)),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.countChatSystems), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "Video",
                        name: "os",
                        id: 'cb_beratung_video',
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedOnlineService) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.checkOnlineService($event))),
                        "aria-controls": "ergebnis-liste"
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.checkedOnlineService]
                      ]),
                      _createElementVNode("label", _hoisted_39, [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.counselingCenters.videoConsult')) + " ", 1),
                        _cache[25] || (_cache[25] = _createElementVNode("i", { class: "icon onb-contact--video" }, null, -1)),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.countVideoSystems), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "Mail",
                        name: "os",
                        id: 'cb_beratung_mail',
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkedOnlineService) = $event)),
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkOnlineService($event))),
                        "aria-controls": "ergebnis-liste"
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.checkedOnlineService]
                      ]),
                      _createElementVNode("label", _hoisted_42, [
                        _createTextVNode(_toDisplayString(_ctx.$t('views.counselingCenters.mailConsult')) + " ", 1),
                        _cache[26] || (_cache[26] = _createElementVNode("i", { class: "icon onb-contact--mail" }, null, -1)),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.countMailSystems), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.filterTargetGroup && _ctx.filterTargetGroup.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('searchlist.targetGroup')), 1),
                    _createElementVNode("ul", _hoisted_45, [
                      _createElementVNode("li", null, [
                        _createElementVNode("div", _hoisted_46, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            value: "",
                            name: "tg",
                            id: "cb_beratung_all",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.checkedTargetGroup) = $event)),
                            checked: _ctx.checkedTargetGroup == '',
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.checkTargetGroup())),
                            "aria-controls": "ergebnis-liste"
                          }, null, 40, _hoisted_47), [
                            [_vModelRadio, _ctx.checkedTargetGroup]
                          ]),
                          _createElementVNode("label", _hoisted_48, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.all')), 1),
                            (_ctx.filteredCenter.length > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.countTargetGroupAll), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_50, "0"))
                          ])
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTargetGroup, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", _hoisted_51, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              value: item.id,
                              name: "tg",
                              id: 'cb_beratung_' + item.id,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkedTargetGroup) = $event)),
                              checked: (item.id === _ctx.checkedTargetGroup && _ctx.countTargetGroup.get(item.id) !== 0),
                              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkTargetGroup())),
                              disabled: _ctx.countTargetGroup.get(item.id) === 0,
                              "aria-controls": "ergebnis-liste"
                            }, null, 40, _hoisted_52), [
                              [_vModelRadio, _ctx.checkedTargetGroup]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label checkbox-label d-flex align-items-center",
                              for: 'cb_beratung_' + item.id
                            }, [
                              _createElementVNode("span", null, _toDisplayString(item.description), 1),
                              (_ctx.filteredCenter.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.countTargetGroup.get(item.id)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_55, "0"))
                            ], 8, _hoisted_53)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.filterLang && _ctx.filterLang.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('searchlist.language')), 1),
                    _createElementVNode("ul", _hoisted_57, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterLang, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", _hoisted_58, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              value: item.id,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.checkedLanguageType) = $event)),
                              name: "lang",
                              id: item.id,
                              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.checkLanguageType($event))),
                              checked: (item.id === _ctx.checkedLanguageType.id && _ctx.countLang.get(item.id) !== 0),
                              disabled: _ctx.countLang.get(item.id) === 0,
                              "aria-controls": "ergebnis-liste"
                            }, null, 40, _hoisted_59), [
                              [_vModelCheckbox, _ctx.checkedLanguageType]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label checkbox-label d-flex align-items-center",
                              for: item.id
                            }, [
                              _createElementVNode("span", null, _toDisplayString(item.description), 1),
                              (_ctx.filteredCenter.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.countLang.get(item.id)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_62, "0"))
                            ], 8, _hoisted_60)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.filterType && _ctx.filterType.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('searchlist.counselingType')), 1),
                    _createElementVNode("ul", _hoisted_64, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterType, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", _hoisted_65, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              value: item.id,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.checkedCounselingType) = $event)),
                              name: "ctype",
                              id: item.id,
                              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.checkCounselingType($event))),
                              checked: (item.id === _ctx.checkedCounselingType.id && _ctx.countCounseling.get(item.id) !== 0),
                              disabled: _ctx.countCounseling.get(item.id) === 0,
                              "aria-controls": "ergebnis-liste"
                            }, null, 40, _hoisted_66), [
                              [_vModelCheckbox, _ctx.checkedCounselingType]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label checkbox-label d-flex align-items-center",
                              for: item.id
                            }, [
                              _createElementVNode("span", null, _toDisplayString(item.description), 1),
                              (_ctx.filteredCenter.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.countCounseling.get(item.id)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_69, "0"))
                            ], 8, _hoisted_67)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("button", {
                  class: "btn btn-primary-custom mb-3 d-block d-md-none w-100",
                  id: "btn-filter-mobile",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openListe()))
                }, _toDisplayString(_ctx.$t('searchlist.save')), 1),
                _createElementVNode("button", {
                  class: "btn btn-link-custom d-block w-100",
                  id: "btn-filter-reset",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.resetFilter()))
                }, _toDisplayString(_ctx.$t('searchlist.resetFilter')), 1)
              ])
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('searchlist.listHL')), 1),
              _createVNode(_component_loading_container, {
                state: _ctx.state,
                i18nErrorMessage: "views.legalEntities.errorMessage"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_Liste, {
                    cCenter: _ctx.filteredCenter,
                    topics: _ctx.topics,
                    key: _ctx.filteredCenter,
                    region: _ctx.regions,
                    lang: _ctx.checkedLanguageType,
                    cType: _ctx.checkedCounselingType,
                    targetGroup: _ctx.checkedTargetGroup,
                    os: _ctx.checkedOnlineService,
                    long: _ctx.long,
                    lat: _ctx.lat,
                    radiusMap: _ctx.radiusMap,
                    searchTerm: _ctx.searchTerm,
                    onSubmit: _ctx.getnewtopics,
                    onResetfilter: _ctx.resetFilter
                  }, null, 8, ["cCenter", "topics", "region", "lang", "cType", "targetGroup", "os", "long", "lat", "radiusMap", "searchTerm", "onSubmit", "onResetfilter"]))
                ]),
                _: 1
              }, 8, ["state"])
            ], 512)
          ])
        ])
      ]),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            _createElementVNode("button", {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.openFilter())),
              id: "switchFilter",
              class: "btn d-flex flex-column btn-switch d-noxne"
            }, [
              _cache[27] || (_cache[27] = _createElementVNode("img", {
                src: _imports_3,
                width: "30",
                height: "30",
                alt: "Icon Filter",
                "aria-hidden": "true",
                class: "mx-auto mb-1"
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.mobileFilter')), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openMap())),
              id: "switchMap",
              class: "btn d-flex flex-column btn-switch d-noxne",
              tabindex: "-1"
            }, [
              _cache[28] || (_cache[28] = _createElementVNode("img", {
                src: _imports_4,
                width: "30",
                height: "30",
                alt: "Icon Map",
                "aria-hidden": "true",
                class: "mx-auto mb-1"
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.mobileMap')), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.openListe())),
              id: "switchListe",
              class: "btn d-flex flex-column btn-switch d-noxne"
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("img", {
                src: _imports_5,
                width: "30",
                height: "30",
                alt: "Icon Liste",
                "aria-hidden": "true",
                class: "mx-auto mb-1"
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.mobileList')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}